;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="add201a9-37ef-4f5e-b028-e80d7b2ddbc2",e._sentryDebugIdIdentifier="sentry-dbid-add201a9-37ef-4f5e-b028-e80d7b2ddbc2")}catch(e){}}();import debounce from '../../node_modules/.pnpm/lodash.debounce@4.0.8/node_modules/lodash.debounce/index.js';
import React__default, { useContext, useState, useRef, useEffect, useCallback } from 'react';
import 'react/jsx-runtime';
import Search from '../../node_modules/.pnpm/@zooplus_icons@2.3.0_react-dom@18.3.1_react@18.3.1/node_modules/@zooplus/icons/dist/es/components/Search.js';
import AppContext from '../../context/AppContext.js';
import '../../_virtual/_sentry-release-injection-file.js';
import { dispatchSearchSuggestionStatusEvent, SearchSuggestionToggleEnum } from '../../tracking/index.js';
import { ThemedIcon } from '../Icon/Icon.js';
import SearchSuggestion from '../SearchSuggestion/SearchSuggestion.js';
import { useSearchEngine } from './engines/index.js';
import styles from './SearchBar.module.scss.js';

const SEARCH_BAR_ID = 'search_query_field';
const DEBOUNCE_TIME = 300;
const SUGGESTIONS_ID = 'srh_suggestions';
function SearchBar({ device, }) {
    const context = useContext(AppContext);
    const [query, setQuery] = useState('');
    const [suggestions, setSuggestions] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [liveMessage, setLiveMessage] = useState('');
    const searchInput = useRef(null);
    const firstRender = useRef(true);
    const initialBodyStyleProperty = useRef(null);
    const { translations } = context;
    function getSearchTermFromQueryMaybe() {
        const param = new URLSearchParams(window.location.search);
        return param.get('q') ?? '';
    }
    function setBodyStyleProperty(width, position) {
        if (document && document.body) {
            document.body.style.width = width;
            document.body.style.position = position;
        }
    }
    function disableBodyScroll() {
        /* Require below code to ensure on suggestion panel activation background does not scroll,
        need property fixed to avoid race condition with burger navigation panel open with overflow hidden */
        if (!initialBodyStyleProperty.current && document.body && document) {
            initialBodyStyleProperty.current = {
                width: `${document.body.style.width}`,
                position: `${document.body.style.position}`,
            };
        }
        if (initialBodyStyleProperty.current &&
            document &&
            document.body &&
            device === 'mobile') {
            const isSuggestionPanelOpen = suggestions !== null &&
                suggestions.suggestionItems.length > 0 &&
                showSuggestions;
            const bodyWidth = isSuggestionPanelOpen
                ? '100%'
                : initialBodyStyleProperty.current.width;
            const bodyPosition = isSuggestionPanelOpen
                ? 'fixed'
                : initialBodyStyleProperty.current.position;
            setBodyStyleProperty(bodyWidth, bodyPosition);
        }
    }
    useEffect(() => {
        if (suggestions !== null) {
            dispatchSearchSuggestionStatusEvent({
                status: showSuggestions
                    ? SearchSuggestionToggleEnum.SHOWN
                    : SearchSuggestionToggleEnum.HIDDEN,
            });
        }
        disableBodyScroll();
    }, [suggestions, showSuggestions]);
    useEffect(() => {
        setSearchTerm(getSearchTermFromQueryMaybe());
        firstRender.current = false;
        return () => {
            if (document && document.body && initialBodyStyleProperty.current) {
                const { current: { width, position }, } = initialBodyStyleProperty;
                setBodyStyleProperty(width, position);
            }
        };
    }, []);
    // For VoiceOver Accessibility
    useEffect(() => {
        let timeoutId;
        if (suggestions && suggestions.suggestionItems.length) {
            const liveMessageLabel = translations.get('shop.header.suggestion.results.aria.label');
            timeoutId = setTimeout(() => {
                if (liveMessageLabel) {
                    setLiveMessage(liveMessageLabel.replace('{0}', `${searchTerm}`));
                }
            }, 1500);
        }
        return () => clearTimeout(timeoutId);
    }, [searchTerm, suggestions?.suggestionItems?.length]);
    const { redirectToSearchResults, fetchSuggestions, redirectToServicePage } = useSearchEngine();
    let timeOutId;
    function onBlur() {
        timeOutId = window.setTimeout(() => {
            setShowSuggestions(false);
        }, 100);
    }
    function onFocus() {
        clearTimeout(timeOutId);
        setShowSuggestions(true);
    }
    async function apiRequest(term) {
        const suggestionsData = await fetchSuggestions(term);
        setQuery(term);
        if (suggestionsData) {
            setSuggestions(suggestionsData);
            setShowSuggestions(true);
        }
        else {
            setShowSuggestions(false);
        }
        return suggestionsData;
    }
    async function onSubmitSearch(event) {
        event.preventDefault();
        let suggestionsData = suggestions;
        if (searchTerm !== query) {
            suggestionsData = await apiRequest(searchTerm);
        }
        if (suggestionsData?.redirectUri !== null &&
            suggestionsData?.redirectUri !== undefined) {
            redirectToServicePage(suggestionsData.redirectUri);
        }
        else {
            redirectToSearchResults(searchTerm);
        }
    }
    const debouncedAutoComplete = useCallback(debounce(apiRequest, DEBOUNCE_TIME), [context.selectedShopLanguage]);
    function handleSearchOnChange(event) {
        event.persist();
        const { target: { value }, } = event;
        setSearchTerm(value);
        if (value.length > 2) {
            debouncedAutoComplete(value);
        }
        else {
            setSuggestions(null);
        }
    }
    function handleKeyUp(e) {
        if (e.key === 'Enter') {
            setShowSuggestions(!showSuggestions);
        }
        else if (e.key === 'Escape') {
            setShowSuggestions(false);
        }
    }
    return (React__default.createElement("search", { role: "presentation", className: styles.searchBarWrapper, onFocus: () => onFocus(), onBlur: () => onBlur(), onKeyUp: (e) => handleKeyUp(e) },
        React__default.createElement("form", { "data-zta": `search_form_${device}`, className: styles.searchForm, name: "miniSearchBox", onSubmit: onSubmitSearch, autoComplete: "off" },
            React__default.createElement("label", { htmlFor: `${SEARCH_BAR_ID}_${device}`, className: styles.accessibleText, id: `${SEARCH_BAR_ID}-label-${device}` }, translations.get('shop.header.search.label')),
            React__default.createElement("input", { "data-zta": `search_form_input_${device}`, id: `${SEARCH_BAR_ID}_${device}`, onChange: (e) => handleSearchOnChange(e), ref: searchInput, value: searchTerm, name: "q", type: "search", inputMode: "search", placeholder: translations.get('shop.header.search.placeholder'), "aria-labelledby": `${SEARCH_BAR_ID}-label-${device}`, "aria-describedby": `${SEARCH_BAR_ID}-description-${device}`, className: styles.searchBarInput }),
            showSuggestions && (React__default.createElement("div", { role: "status", "aria-live": "polite", "aria-atomic": "true", className: styles.srOnly }, liveMessage)),
            showSuggestions &&
                suggestions &&
                suggestions.suggestionItems &&
                suggestions.suggestionItems.length > 0 && (React__default.createElement(SearchSuggestion, { id: SUGGESTIONS_ID, device: device, term: query, suggestions: suggestions.suggestionItems })),
            React__default.createElement("button", { className: styles.submitButton, "data-zta": `search_form_button_${device}`, type: "submit", "aria-labelledby": `${SEARCH_BAR_ID}-label-${device}` },
                React__default.createElement(ThemedIcon, { Icon: Search, color: "primary", "aria-labelledby": `${SEARCH_BAR_ID}-label-${device}` })))));
}

export { SearchBar as default };
//# sourceMappingURL=SearchBar.js.map
